<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                &nbsp;
                <button type="button" class="btn btn-primary" @click="addBonusModal">
                    <icon name="plus"></icon>
                    เพิ่มจังหวัด
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ชื่อ</th>
                    <th scope="col">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in rateBonusList">
                    <td>{{data.provinces.name}}</td>
                    <td>
                        <!--                        <a @click="showAccountDetailsModal(detail.id,data.id)">-->
                        <!--                            <icon name="pencil-alt"></icon>-->
                        <!--                        </a> &nbsp;&nbsp;-->
                        <a @click="deleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-header hide-footer size="lg" ref="add_bonus">
            <div style="text-align: center;">
                <h4>เพิ่มจังหวัด</h4>
                <br />
                <div class="row">
                    <div class="col-2 text-right">
                        <label>จังหวัด</label>
                    </div>
                    <div class="col-8 justify-content-center">
                        <multiselect
                            class="form-control select"
                            v-model="form.provinces"
                            :options="optionProvince"
                            label="name"
                            :show-labels="false"
                            placeholder="เลือกจังหวัด"
                            track-by="id"
                            style="border-style: none">
                        </multiselect>
                    </div>
                </div>
                <br/>
                <div class="row justify-content-center">
                    <button class="btn btn-success" @click="addBonus">บันทึก</button>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <button class="btn btn-secondary" @click="hideModal">ยกเลิก</button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteBonus">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hidedeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Multiselect from "vue-multiselect";

    export default {
        name: "DriverTransportReportList",
        components: {Multiselect},
        data(){
          return{
              form:{
                  provinces:''
              },
              delete_id : ''
          }
        },
        computed:{
            ...mapState({
                rateBonusList :state=>{
                    return state.DriverConfigBonus.ProvinceDriverLists;
                },
                optionProvince:state =>{
                    return state.Common.province;
                },
            }),
        },
        created() {
            this.$store.dispatch('DriverConfigBonus/setDriverProvince');
            this.$store.dispatch('Common/setProvince');

        },
        methods: {
            addBonusModal() {
                this.$refs.add_bonus.show();
            },
            hideModal() {
                this.$refs.add_bonus.hide();
            },
            deleteModal(id) {
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hidedeleteModal() {
                this.$refs.delete_item.hide();
            },
            addBonus() {
                this.$store.dispatch('DriverConfigBonus/saveProvince', {id: null, data: this.form}).then(res => {
                    alert(res)
                    this.form = {
                        provinces: '',
                    };
                    this.setTable();
                    this.hideModal();
                })
            },
            deleteBonus() {
                this.$store.dispatch('DriverConfigBonus/deleteProvince', this.delete_id).then(() => {
                    this.setTable();
                    this.hidedeleteModal();
                    this.delete_id = '';
                });
            },
            setTable() {
                this.$store.dispatch("DriverConfigBonus/setDriverProvince")
            }
        }
    }
</script>

<style scoped>

</style>
